import { Component, Input, Output, EventEmitter, Inject, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Institution } from '@nano/common/finance';
import { PaymentConfig } from '@nano/payment/payment';
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from 'angular-l10n';

@Component({
  selector: 'app-correspondent-bank-information',
  templateUrl: './correspondent-bank-information.component.html',
  standalone: false
})
export class CorrespondentBankInformationComponent implements OnInit {
  @Input() correspondentBankCodeControl: AbstractControl;
  @Input() correspondentBankNameControl: AbstractControl;
  @Input() correspondentBankAddressControl?: AbstractControl;
  @Input() correspondentBankIdentifierControl?: AbstractControl;
  @Input() config: PaymentConfig;
  @Input() showAddressControl = false;
  @Input() showIdentifierControl = false;
  @Input() useSwiftBicCodeLabel = false;
  @Output() institutionSelected = new EventEmitter<Institution>();

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private translationService: L10nTranslationService
  ) {}

  ngOnInit(): void {
    this.showAddressControl = !!this.correspondentBankAddressControl;
    this.showIdentifierControl = !!this.correspondentBankIdentifierControl;
  }

  onInstitutionSelect(event: Institution): void {
    this.institutionSelected.emit(event);
  }

  get correspondentBankCodeLabel(): string {
    const key = this.useSwiftBicCodeLabel ? 'payment.beneficiaryBankIdentifier.label' : 'payment.receiverInfo.correspondentBank.code.label';
    const label = this.translate(key);
    return label === key ? this.translate('payment.receiverInfo.correspondentBank.code.label') : label;
  }

  get correspondentBankCodePlaceholder(): string {
    const key = this.useSwiftBicCodeLabel ? 'payment.beneficiaryBankIdentifier.placeholder' : 'payment.receiverInfo.correspondentBank.code.placeholder';
    const placeholder = this.translate(key);
    return placeholder === key ? this.translate('payment.receiverInfo.correspondentBank.code.placeholder') : placeholder;
  }

  private translate(key: string): string {
    return this.translationService.translate(key, this.locale.language) as string;
  }
}
